import { type ComponentProps } from 'react';

import { css } from '@compiled/react';
import { type FormatDateOptions } from 'react-intl';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import { IconTile } from '@atlaskit/icon-next';
import { token } from '@atlaskit/tokens';

import { type ArticleAccentColor } from '../../jsm-portal-playground-data';

export const BRAND_FONT = '"Work Sans", "Atlassian Sans", sans-serif';

export const BEACON_GRADIENT = 'linear-gradient(90deg, #E1EF8F 0%, #94E7D6 100%)';

export const CARD_DATE_FORMAT: FormatDateOptions = {
	day: 'numeric',
	month: 'long',
	year: 'numeric',
	timeZone: 'UTC',
};

export const ARTICLE_DATE_FORMAT: FormatDateOptions = {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
	timeZone: 'UTC',
};

type IconTileIcon = ComponentProps<typeof IconTile>['icon'];

const BookTileIcon = BookOpenIcon as unknown as IconTileIcon;

export const PortalArticleIconTile = ({
	color,
	size,
}: {
	color: ArticleAccentColor;
	size: 'medium' | 'xlarge';
}) => (
	<IconTile
		icon={BookTileIcon}
		label=""
		appearance={color === 'teal' ? 'tealBold' : 'limeBold'}
		size={size}
	/>
);

const launcherButtonStyles = css({
	position: 'absolute',
	insetInlineEnd: token('space.200'),
	insetBlockEnd: token('space.200'),
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '40px',
	height: '40px',
	borderRadius: token('radius.full'),
	background: BEACON_GRADIENT,
	boxShadow: token('elevation.shadow.overlay'),
});

export const JsmPortalPlaygroundRovoLauncherMark = () => (
	<span css={launcherButtonStyles} aria-hidden="true">
		<AiChatIcon label="" color={token('color.text')} />
	</span>
);
